// extracted by mini-css-extract-plugin
export default {"icon":"Calculator_icon__u2qOr"};